export class dataType{
    public body:any;
    public Status:string;
    public Data:any;
    public Error:any;
    public username:any;
    public temppass:string;
    public email:string;
    public chkemail:boolean;
    public phonenumber:number;
    public chkphonenumber:boolean;
    public sms:boolean;
    public cemail:boolean;
    public bucket: any;
    public uname : any;
    public read : boolean;
    public write : boolean;
    public full : boolean;
    public cread : boolean;
    public cwrite : boolean;
    public cfull : boolean;
    public s3read : boolean;
    public s3write : boolean;
    public s3full : boolean;
    public iamread : boolean;
    public iamwrite : boolean;
    public iamfull : boolean;
    public groupname : string;
    public desc : string;
    public pic :any;
    public fname : string;
}